import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LeadInputComponent } from './lead-input.component';

const routes: Routes = [
  { path: '', component: LeadInputComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeadInputRoutingModule { }
